// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"124":"0c6b508e","349":"c4659d17","620":"17ceee92"}[chunkId] + ".css";
};